import { readStreamableValue } from 'ai/rsc';
import { streamOverview } from '../../app/actions/streamOverview';
import { Pass1LearningPath } from '../../typesV2';

export async function runOverviewStream(
  setOverview: (overview: string) => void,
  setIsStreamingContent: (isStreamingContent: boolean) => void,
  jobTitle: string,
  learningPath: Pass1LearningPath
): Promise<string> {
  let overview = '';
  let error = null;

  const overviewStreamValue = await streamOverview(jobTitle, learningPath);
  const streamValue = readStreamableValue(overviewStreamValue);
  for await (const generatedOverview of streamValue) {
    setOverview(generatedOverview as string);
    overview = generatedOverview as string;
  }

  setIsStreamingContent(false);
  return overview;
}
